import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, RevisionIdSchema } from "../primitives/ids.js";
import { BusinessGraphV1Schema } from "./business-graph.js";
/** BG-007 — revision history list entry (no full graph payload). */
export const BusinessGraphRevisionSummaryV1Schema = z
    .object({
    schemaId: z.literal("businessgraph.revisionSummary.v1"),
    revisionId: RevisionIdSchema,
    snapshotHash: z.string().regex(/^[0-9a-f]{64}$/),
    createdAt: z.string().datetime(),
    /** Null when revision is persisted but not yet the active approved head. */
    activatedAt: z.string().datetime().nullable(),
})
    .strict();
export const BusinessGraphRevisionListV1Schema = z
    .object({
    schemaVersion: z.literal("businessgraph.revisionList.v1"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    revisions: z.array(BusinessGraphRevisionSummaryV1Schema),
})
    .strict();
/** BG-007 — addressable historical or active revision with full graph truth. */
export const BusinessGraphRevisionViewV1Schema = z
    .object({
    schemaId: z.literal("businessgraph.revisionView.v1"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    revisionId: RevisionIdSchema,
    snapshotHash: z.string().regex(/^[0-9a-f]{64}$/),
    createdAt: z.string().datetime(),
    activatedAt: z.string().datetime().nullable(),
    businessGraph: BusinessGraphV1Schema,
})
    .strict();
//# sourceMappingURL=business-graph-revisions.js.map